import * as types from './mutation-types'

export default {
  [types.SET_FAQS] (state, obj) {
    state.faqs = obj
  },
  [types.SET_FAQ] (state, obj) {
    state.faq = obj
  }
}
